
$(document).ready(function () {
	if (!document.getElementById('newsletterForm')) return false;
	var form = {
		el: document.getElementById('newsletterForm'),

		init: function () {
			form.addEvent();
		},
		addEvent: function () {
			// 20200311 START 이지원
			var self = this;
			self.$outer = document.body.parentNode.getAttribute('data-countrycode').toLowerCase();
			self.$province = $(form.el).find('#province');
			self.$province.options = (self.$province) ? self.$province.find("option") : undefined;
			self.$city = $(form.el).find('#city');
			// 20200312 START 이지원
				// self.$url = self.$province.parents('.list-wrapper').attr('data-action');
			// 20200312 END
			$(form.el).find("[type=reset]").on("click", function (e) {
				e.preventDefault();
				form.el.reset();
				selectorBox = $(form.el).find('select');
				selectorBox.each(function () {
					$(this).prop('selectedIndex', 0);
					$(this).trigger("chosen:updated");
				})
			});

			// 20200312 START 이지원
			self.$url = self.$province.parents('.list-wrapper').attr('data-action');
			if (self.$url) {
				self.$province.drawAjaxOptions({
					setTarget: document.getElementById('city'),
					url: self.$url,
					dynamicParam: false,
				})
			}
			// 20200312 END
			// 20200311 END

			/*
			$('#txtBoxPassword, #txtBoxPasswordConfirm').on('keyup input', function (e) {
				if($("#txtBoxPassword").val().length>5 && $('#txtBoxPasswordConfirm').val().length>0 ) {
					if ( $('#txtBoxPassword').val() == $('#txtBoxPasswordConfirm').val() ) {
						$('#txtBoxPasswordConfirm').parents(".field-block").removeClass('error');
					} else {
						$('#txtBoxPasswordConfirm').parents(".field-block").addClass('error').find('.match').show().siblings().hide();
					}
				} else {
					$('#txtBoxPasswordConfirm').parents(".field-block").removeClass('error');
				}
			});
			*/
			$(form.el).find(':radio[id=option_yes]').change(function () {
				$('#radio_box_group').addClass('expanded');
				$(form.el).find(".list-toggle").show();
			});
			$(form.el).find(':radio[id=option_no]').change(function () {
				$('#radio_box_group').removeClass('expanded');
				$(form.el).find(".list-toggle").hide();
			});
            //LGEHK-65
            if($('html').data('countrycode') == 'hk' || $('html').data('countrycode') == 'hk_en'){
                $(form.el).find("[type=submit]").on("click", function (e) {
                    e.preventDefault();
                    
                    $(form.el).find('input').each(function() {
                    	var inputTxt = $(this).val();
                    	$(this).val(xssfilter(inputTxt));
                    });
                    
                    $(form.el).submit();
                    
                });
            }
		},
	};
	form.init();
});
